import { version_env } from 'src/environments/version';

export const environment = {
  production: true,
  localStorage: 'app-cono-sur_user_info_prod',
  countryStorage: 'empty',
  storageBiometric: 'app-cono-sur_user_email_prod',
  // apiUrl: 'https://www.tbtbg-demo.com/api_demo',
  apiUrl: 'https://godxconosur.com/api',
  version: version_env.number + ' - p',
  date: version_env.date,
  menuBar: 'admin-cono-sur_menu_bar_prod',
  sentry: 'https://6650798205a645da8f06ecebae2f7365@o1214263.ingest.sentry.io/6354738',
  key: 'key'
}
